<template>
  <b-navbar
    id="template-header"
    class="navbar default-layout-navbar p-0"
    toggleable="lg"
  >
    <div class="horizontal-menu">
      <nav class="navbar top-navbar col-lg-12 col-12 p-0">
        <div class="container">
          <div
            class="
              text-center
              navbar-brand-wrapper
              d-flex
              align-items-center
              justify-content-center
            "
          >
            <router-link class="navbar-brand brand-logo" to="/">
              <img src="@/assets/images/logo-desktop.png" alt="logo" />
            </router-link>
            <router-link class="navbar-brand brand-logo-mini" to="/">
              <img src="@/assets/images/logo-mini.svg" alt="logo" />
            </router-link>
          </div>

          <div
            class="
              navbar-menu-wrapper
              d-flex
              align-items-center
              justify-content-end
            "
          >
            <ul class="navbar-nav mr-lg-2" v-if="!isCustomer">
              <li class="nav-item nav-search d-none d-lg-block">
                <div class="input-group">
                  <div
                    class="input-group-prepend hover-cursor"
                    id="navbar-search-icon"
                  >
                    <span class="input-group-text" id="search">
                      <i class="mdi mdi-magnify"></i>
                    </span>
                  </div>
                  <input
                    v-model="searchkey"
                    v-on:keyup.enter="search"
                    type="text"
                    class="form-control"
                    id="navbar-search-input"
                    placeholder="Suche"
                    aria-label="search"
                    aria-describedby="search"
                  />
                </div>
              </li>
            </ul>

            <b-navbar-nav class="navbar-nav-right ml-auto">
              <b-nav-item-dropdown right class="nav-profile">
                <template slot="button-content">
                  <span
                    class="nav-link dropdown-toggle"
                    id="profileDropdown"
                    href="javascript:void(0);"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div class="nav-profile-text">
                      <p class="mb-1 text-black">{{ userName }}</p>
                    </div>
                  </span>
                </template>
                <!--
                <b-dropdown-item class="preview-item">
                  <i class="mdi mdi-cached mr-2 text-success"></i> Profil
                </b-dropdown-item>
                -->
                <b-dropdown-item class="preview-item" @click="logout()">
                  <i class="mdi mdi-logout mr-2 text-primary"></i> Ausloggen
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
            <button
              class="navbar-toggler navbar-toggler-right align-self-center"
              type="button"
              @click="toggleMobileSidebar()"
            >
              <span class="mdi mdi-menu"></span>
            </button>
          </div>
        </div>
      </nav>
      <nav class="bottom-navbar">
        <div class="container">
          <ul class="nav page-navigation">
            <li class="nav-item">
              <router-link class="nav-link" to="/">
                <i class="mdi mdi-home menu-icon"></i>
                <span class="menu-title">Start</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/locations/">
                <i class="mdi mdi-city menu-icon"></i>
                <span class="menu-title">Einrichtungen</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isCustomer">
              <router-link class="nav-link" to="/billings/">
                <i class="mdi mdi-city menu-icon"></i>
                <span class="menu-title">Rechnungen</span>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isCustomer">
              <router-link class="nav-link" to="/settings/">
                <i class="mdi mdi-settings menu-icon"></i>
                <span class="menu-title">Einstellungen</span>
              </router-link>
            </li>

            <!--
            <li class="nav-item mega-menu">
              <a href="javascript:void(0);" class="nav-link">
                <i class="mdi mdi-crosshairs-gps menu-icon"></i>
                <span class="menu-title">UI Elements</span>
                <i class="menu-arrow"></i>
              </a>
              <div class="submenu">
                <div class="col-group-wrapper row">
                  <div class="col-group col-md-4">
                    <div class="row">
                      <div class="col-12">
                        <p class="category-heading">Basic Elements</p>
                        <div class="submenu-item">
                          <div class="row">
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/accordions/">Accordion</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/alerts/">Alerts</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/badges/">Badges</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/breadcrumbs/">Breadcrumbs</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/buttons/">Buttons</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/dropdowns/">Dropdowns</router-link>
                                </li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/modals/">Modals</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/paginations/">Paginations</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/progress/">Progress</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/tabs/">Tabs</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/tooltips/">Tooltips & Popovers</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/basic-ui/typography/">Typography</router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-group col-md-4">
                    <div class="row">
                      <div class="col-12">
                        <p class="category-heading">Advanced Elements</p>
                        <div class="submenu-item">
                          <div class="row">
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/dragula/">Dragula</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/carousel/">Carousel</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/loaders/">Loaders</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/slider/">Slider</router-link>
                                </li>
                              </ul>
                            </div>
                            <div class="col-md-6">
                              <ul>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/clipboard/">Clipboard</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/tree-view/">Tree View</router-link>
                                </li>
                                <li class="nav-item">
                                  <router-link class="nav-link" to="/advanced-ui/context-menu/">Context Menu</router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-group col-md-4">
                    <p class="category-heading">Icons</p>
                    <ul class="submenu-item">
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/flag-icons/">Flag icons</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/fontawesome/">Font Awesome</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/mdi-icons/">MDI</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/simpleline/">Simple line icons</router-link>
                      </li>
                      <li class="nav-item">
                        <router-link class="nav-link" to="/icons/themify-icons/">Themify icons</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            -->
          </ul>
        </div>
      </nav>

      <b-modal id="bv-modal-example" size="lg" scrollable hide-footer hide-header body-class="p-0">

        <!-- Loading -->
        <div v-if="searchLoading" class="search-state">
          <b-spinner variant="primary" small></b-spinner>
          <span class="ml-2 text-muted">Suche läuft...</span>
        </div>

        <!-- Error -->
        <div v-else-if="searchError" class="search-state">
          <span class="text-danger">Fehler bei der Suche. Bitte erneut versuchen.</span>
        </div>

        <!-- No Results -->
        <div v-else-if="hasNoResults" class="search-state">
          <span class="text-muted">Keine Ergebnisse für "{{ searchkey }}"</span>
        </div>

        <!-- Results -->
        <div v-else>

          <!-- Einrichtungen -->
          <div v-if="searchresult.length > 0" class="search-section">
            <div class="search-section-label">Einrichtungen</div>
            <router-link
              v-for="item in searchresult"
              :key="'loc-' + item.uid"
              target="_blank"
              class="search-item"
              :to="{ name: 'location-detail', params: { uid: item.uid } }"
            >
              <div class="search-item-main">
                <span class="search-item-name">{{ item.name }}</span>
                <span class="search-item-badge" :class="'badge-' + (item.account_state || 'unknown')">
                  {{ stateBadge(item.account_state).label }}
                </span>
              </div>
              <div class="search-item-sub">
                <span v-if="item.category">{{ item.category }}</span>
                <span v-if="item.subdomain">{{ item.subdomain }}</span>
                <span v-if="item.kindy_id">{{ item.kindy_id }}</span>
              </div>
            </router-link>
          </div>

          <!-- Rechnungen -->
          <div v-if="billingResults.length > 0" class="search-section">
            <div class="search-section-label">Rechnungen</div>
            <div
              v-for="(bill, idx) in billingResults"
              :key="'bill-' + idx"
              class="search-item"
            >
              <div class="search-item-main">
                <span>
                  <a v-if="bill.download_file" :href="bill.download_file" target="_blank" class="search-item-name">
                    Nr. {{ bill.invoice_number || bill.invoice_nr }}
                  </a>
                  <span v-else class="search-item-name">Nr. {{ bill.invoice_number || bill.invoice_nr || '–' }}</span>
                  <span class="search-item-badge" :class="bill.is_paid ? 'badge-customer' : 'badge-close'">
                    {{ bill.is_paid ? 'bezahlt' : 'offen' }}
                  </span>
                </span>
                <span class="search-item-amount">{{ (bill.invoice_amount / 100) | toCurrency }}</span>
              </div>
              <div class="search-item-sub">
                <span v-if="bill.kindy_id">{{ bill.kindy_id }}</span>
                <span v-if="bill.created_at">{{ bill.created_at | moment(' D.MM.YYYY') }}</span>
                <router-link
                  v-if="bill.location_uid"
                  target="_blank"
                  :to="{ name: 'location-detail', params: { uid: bill.location_uid } }"
                  @click.native.stop
                >→ Account öffnen</router-link>
              </div>
            </div>
          </div>

          <!-- Mitarbeiter -->
          <div v-if="staffResults.length > 0" class="search-section">
            <div class="search-section-label">Mitarbeiter</div>
            <div
              v-for="(staff, idx) in staffResults"
              :key="'staff-' + idx"
              class="search-item"
            >
              <div class="search-item-main">
                <span class="search-item-name">{{ staff.name }}</span>
                <span class="text-muted" style="font-size: 0.82rem;">{{ staff.email }}</span>
              </div>
            </div>
          </div>

        </div>
      </b-modal>
    </div>
  </b-navbar>
</template>

<script>
import { searchFull } from "@/services/locations.service";

export default {
  name: "app-header",
  data() {
    return {
      searchkey: null,
      searchresult: [],
      billingResults: [],
      staffResults: [],
      searchLoading: false,
      searchError: false,
    };
  },
  computed: {
    userName: function () {
      var user = this.$store.state.user;
      if (user && user.name) return user.name;
      if (user && user.email) return user.email;
      return 'Eingeloggt';
    },
    isCustomer: function () {
      return (
        this.$store.state.user_customer &&
        this.$store.state.user_company &&
        this.$store.state.user_company.length > 2
      );
    },
    hasNoResults: function () {
      return !this.searchLoading && this.searchresult.length === 0 && this.billingResults.length === 0 && this.staffResults.length === 0;
    },
    resultCount: function () {
      return this.searchresult.length + this.billingResults.length + this.staffResults.length;
    },
  },
  mounted() {
    var navItems = document.querySelectorAll(
      ".horizontal-menu .page-navigation >.nav-item"
    );
    document
      .querySelectorAll(".horizontal-menu .page-navigation >.nav-item")
      .forEach(function (el) {
        el.addEventListener("click", function () {
          for (var i = 0; i < navItems.length; i++) {
            if (navItems[i] == el) {
              el.classList.toggle("show-submenu");
            } else {
              navItems[i].classList.remove("show-submenu");
            }
          }
        });
      });
  },
  methods: {
    openLocation: (item) => {
      console.log(item);
    },
    toggleMobileSidebar: () => {
      document
        .querySelector(".bottom-navbar")
        .classList.toggle("header-toggled");
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    handleSCroll() {
      let header = document.querySelector("body");
      if (window.scrollY > 70) {
        header.classList.add("fixed-on-scroll");
      } else {
        header.classList.remove("fixed-on-scroll");
      }
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push({ name: "login" });
    },
    stateBadge(state) {
      var map = {
        customer: { variant: 'success', label: 'Kunde' },
        test: { variant: 'warning', label: 'Test' },
        forfree: { variant: 'info', label: 'Kostenlos' },
        close: { variant: 'secondary', label: 'Geschlossen' },
      };
      return map[state] || { variant: 'light', label: state || 'Unbekannt' };
    },
    search() {
      if (!this.searchkey) return;

      this.$bvModal.show("bv-modal-example");

      this.searchresult = [];
      this.billingResults = [];
      this.staffResults = [];
      this.searchLoading = true;
      this.searchError = false;

      searchFull({ searchkey: this.searchkey })
        .then((d) => {
          this.searchresult = d.data.loc_findings || [];
          this.billingResults = d.data.billing_entries || [];
          this.staffResults = d.data.location_staff_entries || [];
        })
        .catch(() => {
          this.searchError = true;
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },
  },
  created() {
    window.addEventListener("scroll", this.handleSCroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleSCroll);
  },
  watch: {
    $route() {
      document
        .querySelector(".bottom-navbar")
        .classList.remove("header-toggled");
    },
  },
};
</script>

<style scoped>


.bottom-navbar {
  background-color: #00b3fc;
}

.page-navigation {
  justify-content: flex-start !important;
}

.page-navigation .nav-item .nav-link.router-link-active {
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-weight: bold;
}

.search-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.search-section {
  padding: 0;
}

.search-section + .search-section {
  border-top: 1px solid #eef0f2;
}

.search-section-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a0a4a8;
  padding: 14px 20px 6px;
}

.search-item {
  display: block;
  padding: 10px 20px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: background 0.1s;
}

.search-item:hover {
  background: #f7f8fa;
  text-decoration: none;
  color: inherit;
}

.search-item-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-item-name {
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.92rem;
}

a.search-item-name:hover {
  color: #198ae3;
}

a.search-item .search-item-name {
  color: #198ae3;
}

.search-item-badge {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 3px;
  margin-left: 8px;
  vertical-align: middle;
}

.badge-customer { background: #e6f9ee; color: #1a7a42; }
.badge-test { background: #fff8e6; color: #9a7b1a; }
.badge-forfree { background: #e8f4fd; color: #1a6b9a; }
.badge-close { background: #f2f2f2; color: #666; }
.badge-unknown { background: #f2f2f2; color: #999; }

.search-item-sub {
  display: flex;
  gap: 12px;
  margin-top: 3px;
  font-size: 0.78rem;
  color: #999;
}

.search-item-sub a {
  color: #198ae3;
  text-decoration: none;
}

.search-item-sub a:hover {
  text-decoration: underline;
}

.search-item-amount {
  font-size: 0.88rem;
  font-weight: 500;
  color: #2c3e50;
  white-space: nowrap;
}
</style>